<template>
  <div class="footerFrame">
    <div class="footer">
      <div class="footerTitle">MadSci Lab</div>

      <div class="footerLinks">
        <a href="#" @click="backToTop()">Back to Top</a>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import { EventBus } from "@/event-bus.js";

export default {
  methods: {
    handleOverHeader: function () {
      if (this.isOver == false) {
        this.isOver = true;

        gsap.to(".header", {
          duration: 0.35,
          height: 150,
        });
      }
    },
    handleLeaveHeader: function () {
      this.isOver = false;

      gsap.to(".header", {
        duration: 1.5,
        height: 50,
      });
    },
    backToTop: function () {
      EventBus.$emit("back-to-top");
    },
  },
  computed: {
    getHeader: function () {
      return "header";
    },
  },
  created() {},
  props: {
    pScrollLoc: Number,
  },
  data() {
    return {
      isOver: false,
    };
  },
};
</script>

<style>
.footer {
  width: 99vw;
  border: solid 1px #11111144;
  height: 40px;
  position: relative;
  z-index: 10;
  background-color: #474547;
  color: #ffffff;
  box-shadow: 0 -2px 2px rgba(0, 0, 0, 0.06), 0 -2px 2px rgba(0, 0, 0, 0.06);
}

.footer a {
  color: #ffffff;
}

.footer a:hover {
  color: #ffffff;
}

.footerTitle {
  padding: 15px;
  padding-top: 10px;
  font-weight: 700;
}

.footerLinks {
  font-size: 20px;
  position: absolute;
  right: 20px;
  top: 5px;
}

.footerFrame {
  position: fixed;
  z-index: 10;
  left: 0px;
  width: 100%;
  padding: 6px;

  text-align: left;
  font-size: 14px;
}
</style>